import {
  AcceptanceFormPage,
  CskhPage,
  KhoLeadConfigPage,
  BaoCaoPage,
  HoTroPage,
  CauHinhDanhMucPage,
  DanhSachThiPage,
  FoThucDonLayout,
  He,
  HocSinhLayout,
  HocSinhPhuHuynhPage,
  HomePage,
  Khoi,
  KhoiHePage,
  KyThi,
  KyThiMonThi,
  LoaiGiayTo,
  Lop,
  LopHanhChinhPage,
  MonThi,
  NguonBietToiLayout,
  NguonBietToiPage,
  NoiTruLayout,
  PhongThiPage,
  PhuHuynhPage,
  SendEmailLayout,
  SucKhoeLayout,
  SurveyForm,
  SurveyLayout,
  ThangDiem,
  ThiSinh,
  ThongKePage,
  ThongTinCbnvPage,
  TongHopLayout,
  Truong,
  ThoiHocBaoLuu,
  MonThiDauVaoPage,
  ThiDauVaoPage,
  TrangThaiThiSinhPage,
  KetQuaThiDauVaoPage,
  ThiTuyenSinhLayout,
  AppYeuCauHoTroDetailPage,
  QuanHePage,
  TinhTrangHonNhanPage,
  TinhNew,
  HotlinePage,
  DangKyAnBanTru,
  DangKyXeBusPage,
  DangKyTuyenSinhPage,
  PhiGhiDanhPage,
  PhiDuTuyenPage,
  NhapDiemThiPage,
  LichSuDiemThiPage,
  KetQuaThiPage,
  NhomMonThi,
  ChecklistPage,
  ChecklistHocSinhPage,
  BaoCaoChecklistPage,
  NhomGiaoVien,
} from './pages';
import { redirectTo } from './components/route-redirect';
import BHYTPage from './pages/bhyt';
import Faceid from './pages/face-id';
import LichSuXuongPhongYTe from './pages/lich-su-y-te';
import TongHopGiayTo from './pages/tong-hop-giay-to';

const routes = [
  {
    path: "/nhom-giao-vien",
    component: NhomGiaoVien,
  },
  {
    path: "/home/:tab?",
    component: HomePage,
  },
  {
    path: "/dashboard",
    component: ThongKePage,
  },
  {
    path: "/ds_hoc_sinh_lop/:tab?",
    component: LopHanhChinhPage,
  },


  {
    path: "/crm_survey/form/:id",
    component: SurveyForm,
  },
  {
    path: "/crm_survey/:tab?",
    component: SurveyLayout,
  },

  {
    path: "/nguon_biet_toi/:tab?",
    component: NguonBietToiLayout,
  },
  {
    path: "/dm_trangthaihocsinh/:tab?",
    component: HocSinhPhuHuynhPage,
  },
  {
    path: "/loai_giay_to/:tab?",
    component: LoaiGiayTo,
  },
  {
    path: "/nguon_biet_toi/:tab?",
    component: NguonBietToiPage,
  },
  {
    path: "/doi-tuong-tuyen-sinh/:tab?",
    component: redirectTo(() => "/cau-hinh-danh-muc/doi-tuong-tuyen-sinh"),
  },
  {
    path: "/trang-thai-lead/:tab?",
    component: redirectTo(() => "/cau-hinh-danh-muc/trang-thai-lead"),
  },
  {
    path: "/loai-lien-he/:tab?",
    component: redirectTo(() => "/cau-hinh-danh-muc/loai-lien-he"),
  },
  {
    path: "/ket-qua-lien-he/:tab?",
    component: redirectTo(() => "/cau-hinh-danh-muc/ket-qua-lien-he"),
  },
  {
    path: "/send-email/:tab?",
    component: SendEmailLayout,
  },
  {
    path: "/hoc-sinh/:tab?",
    component: HocSinhLayout,
  },
  {
    path: "/food/:tab?",
    component: FoThucDonLayout,
  },
  {
    path: "/phu-huynh/:tab?",
    component: PhuHuynhPage,
  },
  {
    path: "/acceptance-form/:tab?",
    component: AcceptanceFormPage,
  },
  {
    path: "/truong/:tab?",
    component: Truong,
  },
  {
    path: "/tinh-new/:tab?",
    component: TinhNew,
  },
  {
    path: "/he/:tab?",
    component: He,
  },
  {
    path: "/khoi/:tab?",
    component: Khoi,
  },
  {
    path: "/khoi_he/:tab?",
    component: KhoiHePage,
  },
  {
    path: "/lop/:tab?",
    component: Lop,
  },
  {
    path: "/suc-khoe/:tab?",
    component: SucKhoeLayout,
  },
  {
    path: "/thang-diem/:tab?",
    component: ThangDiem,
  },
  {
    path: "/mon-thi/:tab?",
    component: MonThi,
  },
  {
    path: "/nhom-mon-thi",
    component: NhomMonThi,
  },
  {
    path: '/ky-thi/:tab?',
    component: KyThi
  },
  {
    path: '/thongtin-cbnv/:tab?',
    component: ThongTinCbnvPage,
  },
  {
    path: "/ky-thi",
    component: KyThi,
  },
  {
    path: "kythi-monthi/:tab?",
    component: KyThiMonThi,
  },
  {
    path: "thi-sinh/:tab?",
    component: ThiSinh,
  },
  {
    path: "danh-sach-thi/:tab?",
    component: DanhSachThiPage,
  },
  {
    path: "phong-thi/:tab?",
    component: PhongThiPage,
  },

  {
    path: "/noi-tru/:tab?",
    component: NoiTruLayout,
  },
  {
    path: "/tong-hop/:tab?",
    component: TongHopLayout,
  },

  {
    path: "/tong-hop-giay-to/:tab?",
    component: TongHopGiayTo,
  },
  {
    path: "/face-id/:tab?",
    component: Faceid,
  },
  {
    path: "/cskh/:tab?",
    component: CskhPage,
  },
  {
    path: "/kho-lead/cau-hinh-phan-bo",
    component: KhoLeadConfigPage,
  },
  {
    path: "/crm_bao_cao/:tab?",
    component: BaoCaoPage,
  },
  {
    path: "/ho-tro/:tab?",
    component: HoTroPage,
  },
  {
    path: "/cau-hinh-danh-muc/:tab?",
    component: CauHinhDanhMucPage,
  },
  {
    path: "/thong-ke",
    component: ThongKePage,
  },
  {
    path: "/thoi-hoc-bao-luu",
    component: ThoiHocBaoLuu,
  },
  {
    path: "/monthidauvao/:tab?",
    component: MonThiDauVaoPage,
  },
  {
    path: "/thidauvao/:tab?",
    component: ThiDauVaoPage,
  },
  {
    path: "/ex_trangthai_thisinh/:tab?",
    component: TrangThaiThiSinhPage,
  },
  {
    path: "/ketqua-thidauvao/:tab?",
    component: KetQuaThiDauVaoPage,
  },
  {
    path: "/ket-qua-thi",
    component: KetQuaThiPage,
  },
  {
    path: "/thi-tuyen-sinh/:tab?",
    component: ThiTuyenSinhLayout,
  },
  {
    path: "/nhap-diem-thi",
    component: NhapDiemThiPage,
  },
  {
    path: "/lich-su-diem-thi",
    component: LichSuDiemThiPage,
  },
  {
    path: "/quan-ly-ho-tro/:tab?",
    component: redirectTo(params => `/ho-tro/${params.tab ?? "muc-do-nghiem-trong"}`),
  },
  {
    path: "/app-yeu-cau-ho-tro",
    component: redirectTo(() => "/ho-tro/yeu-cau"),
  },
  {
    path: "/app-yeu-cau-ho-tro/:id",
    component: AppYeuCauHoTroDetailPage,
  },
  {
    path: "/quan-he/:tab?",
    component: QuanHePage,
  },
  {
    path: "/tinh-trang-hon-nhan/:tab?",
    component: TinhTrangHonNhanPage,
  },
  {
    path: "/hotline/:tab?",
    component: HotlinePage,
  },
  {
    path: "/bhyt/:tab?",
    component: BHYTPage,
  },
  {
    path: "/lich-su-xuong-phong-y-te/:tab?",
    component: LichSuXuongPhongYTe,
  },
  {
    path: "/dang-ky-an-ban-tru",
    component: DangKyAnBanTru,
  },
  {
    path: "/dang-ky-xe-bus",
    component: DangKyXeBusPage,
  },
  {
    path: "/dang-ky-tuyen-sinh",
    component: DangKyTuyenSinhPage,
  },
  {
    path: "/phi-ghi-danh",
    component: PhiGhiDanhPage,
  },
  {
    path: "/phi-du-tuyen",
    component: PhiDuTuyenPage,
  },
  {
    path: "/checklist/:tab?",
    component: ChecklistPage,
  },
  {
    path: "/checklist_hocsinh/:tab?",
    component: ChecklistHocSinhPage,
  },
  {
    path: "/checklist-hocsinh/:tab?",
    component: ChecklistHocSinhPage,
  },
  {
    path: "/bao-cao-checklist/:tab?",
    component: BaoCaoChecklistPage,
  },
  {
    path: "/checklist-bao-cao/:tab?",
    component: BaoCaoChecklistPage,
  },
];

export default routes.map((route) => {
  return {
    ...route,
  };
});
